import { ActivityManagement } from "@/components/ActivityManagement";

export default function ActivityPage() {
  return <ActivityManagement />;
}


